<script setup lang="ts">
import BaseLayout from "./base.vue";
</script>

<template>
  <base-layout>
    <template #header>
      <import-header>
        <slot name="header">
          <layout-dynamic-region region="header" classes="contents empty:block" />
        </slot>
      </import-header>
    </template>

    <slot />

    <template #footer>
      <version-footer />
    </template>
  </base-layout>
</template>
